import store, { useContext } from 'nette-base-module/js/store'

useContext(require.context(
  // root folder for components
  './modules/',
  // recursive
  true,
  // include all .js wo index.js
  /\/.*\.js$/,
))

export default store